import { Actions } from 'actions/scoreResults';
import { AxiosError } from 'axios';
import { DeepReadonly } from 'utility-types';
import { IClientScoreResult } from 'interfaces/scoreResult';
import { IReleaseStatus } from '@pec/aion-ui-core/interfaces/release';

export type State = DeepReadonly<{
  isFetching: boolean;
  scoreResults: IClientScoreResult[] | null;
  error: AxiosError | null;
}>;

const initialState: State = {
  isFetching: false,
  scoreResults: null,
  error: null
};

export function reducer(state: State = initialState, action: Actions): State {
  switch (action.type) {
    case 'FETCH_SCORE_RESULTS_REQUEST':
      return {
        ...state,
        isFetching: true
      };
    case 'FETCH_SCORE_RESULTS_SUCCESS':
      const clientScoreResults: IClientScoreResult[] = [];
      const { clients, scores } = action.payload;
      const approvedClients = clients.filter(({ status }) => status === IReleaseStatus.Approved);

      scores.forEach(score => {
        const client = approvedClients.filter(({ releasedToId }) => releasedToId === score.clientId)[0];
        client &&
          clientScoreResults.push({
            ...score,
            clientName: client.releasedToOrganizationName
          });
      });

      return {
        isFetching: false,
        scoreResults: action.payload.scores,
        error: null
      };
    case 'FETCH_SCORE_RESULTS_FAILURE':
      return {
        ...state,
        isFetching: false,
        error: action.error
      };
    default:
      return state;
  }
}
